"use client";

export default function CookiePreferences() {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event("growthrail:open-consent"))}
      className="text-sm text-zinc-400 transition-colors hover:text-copper-300"
    >
      Cookie preferences
    </button>
  );
}
